import React, { useEffect } from 'react';
import classNames from 'classnames';
import CSSMotion from 'rc-motion';
import TreeNode from './TreeNode';
import { getTreeNodeProps } from './utils/treeUtil';
import { TreeContext } from './contextTypes';
const MotionTreeNode = ({ className, style, motion, motionNodes, motionType, onMotionStart: onOriginMotionStart, onMotionEnd: onOriginMotionEnd, active, treeNodeRequiredProps, ...props }, ref) => {
    const [visible, setVisible] = React.useState(true);
    const { prefixCls, ripple } = React.useContext(TreeContext);
    const motionedRef = React.useRef(false);
    const onMotionEnd = () => {
        if (!motionedRef.current) {
            onOriginMotionEnd();
        }
        motionedRef.current = true;
    };
    useEffect(() => {
        if (motionNodes && motionType === 'hide' && visible) {
            setVisible(false);
        }
    }, [motionNodes]);
    useEffect(() => {
        // Trigger motion only when patched
        if (motionNodes) {
            onOriginMotionStart();
        }
        return () => {
            if (motionNodes) {
                onMotionEnd();
            }
        };
    }, []);
    if (motionNodes) {
        return (React.createElement(CSSMotion, Object.assign({ ref: ref, visible: visible }, motion, { motionAppear: motionType === 'show', onAppearEnd: onMotionEnd, onLeaveEnd: onMotionEnd }), ({ className: motionClassName, style: motionStyle }, motionRef) => (React.createElement("div", { ref: motionRef, className: classNames(`${prefixCls}-treenode-motion`, motionClassName), style: motionStyle }, motionNodes.map((treeNode) => {
            const { data: { key, ...restProps }, isStart, isEnd, } = treeNode;
            delete restProps.children;
            const treeNodeProps = getTreeNodeProps(key, treeNodeRequiredProps);
            return (React.createElement(TreeNode, Object.assign({}, restProps, treeNodeProps, { active: active, data: treeNode.data, key: key, isStart: isStart, isEnd: isEnd, ripple: ripple })));
        })))));
    }
    return React.createElement(TreeNode, Object.assign({ domRef: ref, className: className, style: style }, props, { active: active }));
};
MotionTreeNode.displayName = 'MotionTreeNode';
const RefMotionTreeNode = React.forwardRef(MotionTreeNode);
export default RefMotionTreeNode;
